import { render, staticRenderFns } from "./XYTitle.vue?vue&type=template&id=a732bdc4&scoped=true&"
import script from "./XYTitle.vue?vue&type=script&lang=js&"
export * from "./XYTitle.vue?vue&type=script&lang=js&"
import style0 from "./XYTitle.vue?vue&type=style&index=0&id=a732bdc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a732bdc4",
  null
  
)

export default component.exports